import { filter, map } from 'rxjs/operators';

import { saveBusinessInfoOne } from '../../../features/application/reducers/business-info';
import { nextStep } from '../../../features/application/reducers/next-step';
import { RootEpic } from '../index';

export const saveBusinessInfoOneEpic: RootEpic = (action$) =>
  action$.pipe(
    filter(saveBusinessInfoOne.match),
    map(() =>
      nextStep({
        action: 'collect_business_and_applicant_info',
        page: 'business_info_1',
        gotoNextPage: true,
      }),
    ),
  );
